import React from 'react';

export const projectCompanyNameOrEmpty = (companyName?: string | null) =>
  companyName?.trim() || '–';

export function ProjectCompanyName({
  companyName,
  className
}: {
  companyName?: string | null;
  className?: string;
}) {
  return (
    <span className={className} data-testid="project-company-name">
      {projectCompanyNameOrEmpty(companyName)}
    </span>
  );
}
